import Api from "./Api";
// import SiteService from "@/services/SiteService";
// import OrderService from "@/services/OrderService";
// import PartService from "@/services/PartService";
// import FinanceService from "@/services/FinanceService";
import store from "../store/index";
// import InvoiceService from "./InvoiceService";

export default {
  changeLang(obj) {
    return Api().post("change-language", obj);
  },
  createNewPassword(email, password, token) {
    return Api().post("create-new-password", {
      email: email,
      password: password,
      token: token,
    });
  },
  resetPass(userEmail) {
    return Api().post("reset-password", { userEmail: userEmail });
  },
  login(credentials) {
    return Api().post("auth/login", credentials);
  },
  verifyOtp(credentials) {
    return Api().post("auth/verifyOtp", credentials);
  },
  setUserMailing(data) {
    return Api().post("auth/setUserMailing", data);
  },
  isUserExpired() {
    return Api().get("auth/isUserExpired");
  },
  getCustomerBalance() {
    return Api().get("auth/getCustomerBalance");
  },
  getData() {
    return Api().post("customer");
  },
  async getBigData() {
    /*-get user data:-*/
    try {
      await store.dispatch("Orders/getUserCart");
      await store.dispatch("Orders/getTaxPercent");
      await store.dispatch("Orders/getNumberOfDaysToDelivery");
      // await store.dispatch("/getNumberOfDaysToDelivery");

      const userCust = store.getters["AuthModule/getUserCust"];
      // get data when a user is authenticated
      if (userCust) {
        store.dispatch("Alert/popupBycust", {
          cust: userCust,
        });
        // await store.dispatch("Alert/alerts");
        // await store.dispatch("Alert/lastAlert");
        // await store.dispatch("Alert/promotions");
      }

      // await store.dispatch("Orders/getOrders");

      // await store.dispatch("Orders/getOrdersToAprove");

      // console.log(store.getters["AuthModule/getCustomerData"]?.stcode ?? 1);
      // console.log(store.getters);

      // await store.dispatch("shipTypes/getShipTypes");

      // let invoiceRes = await InvoiceService.getInvoices({});

      // store.dispatch("Invoices/updateInvoices", invoiceRes.data);

      // let returnCustDocRes = await InvoiceService.getReturnCustDocs({});

      // store.dispatch("Invoices/updateReturnCustDocs", returnCustDocRes.data);

      // await store.dispatch("Finances/getFinances");

      // await store.dispatch("Finances/getCatalogue");

      return true;
    } catch {
      return false;
    }
  },
};
